// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"f90aa5b0","872":"a507b80c"}[chunkId] + ".chunk.css";
};